/**
 * Calculates a duration given a start and end time. If either time is invalid, returns undefined.
 *
 * @param [capsuleStart] - Start time to evaluate, in milliseconds
 * @param [capsuleEnd] - End time to evaluate, in milliseconds
 * @returns calculated duration, in milliseconds
 */
export function getCapsuleDuration(capsuleStart?: unknown, capsuleEnd?: unknown): number | undefined {
  return typeof capsuleStart === 'number' &&
    Number.isFinite(capsuleStart) &&
    typeof capsuleEnd === 'number' &&
    Number.isFinite(capsuleEnd)
    ? capsuleEnd - capsuleStart
    : undefined;
}
